import { useEffect, useRef, useState } from 'react';
import { locationSocket } from '@/api/client/socket'; // ✅ Updated import
import { useAuth } from '@/providers/AuthProvider';
import { toast } from 'sonner';
import { getActiveShift, toggleShift } from '@/api/shifts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { handleAPIError } from '@/utils/errorHandler';

export const useToggleShift = () => {
  const queryClient = useQueryClient();
  const { organization, user } = useAuth();
  const orgId = organization?.id;
  const userId = user?.id;

  const mutation = useMutation({
    mutationFn: () => toggleShift(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['shift', 'active', orgId, userId],
      });
    },
    onError: (error) => {
      handleAPIError(error);
    },
  });

  return {
    toggleShift: mutation.mutate,
    toggleShiftAsync: mutation.mutateAsync,
    isToggling: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
  };
};

export const useActiveShift = () => {
  const { organization, user } = useAuth();
  const orgId = organization?.id;
  const userId = user?.id;

  const query = useQuery({
    queryKey: ['shift', 'active', orgId, userId],
    queryFn: () => getActiveShift(),
    enabled: !!orgId || !!userId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
};
